import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';

import { ApiRequestDescriptor } from '../../services';

const ENDPOINT =
  `${APIConfiguration.document}files/${COMMON_QUERY_PARAMS.FILE_ID}/documents/${COMMON_QUERY_PARAMS.DOCUMENT_TYPE}/status`;

export interface GetDocumentStatusByFileRequestArgs {
  fileId: string;
  type: string;
}

export const getDocumentStatusByFileRequest = ({
  fileId,
  type,
}: GetDocumentStatusByFileRequestArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId).replace(
    COMMON_QUERY_PARAMS.DOCUMENT_TYPE,
    type,
  ),
  config: { method: SUPPORTED_METHODS.GET },
});
